// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap .werp-img[data-v-75af369d] {\n  width: 30px;\n  height: 30px;\n  margin-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
